import script from "./AdminPagination.vue?vue&type=script&lang=ts"
export * from "./AdminPagination.vue?vue&type=script&lang=ts"

import "./AdminPagination.vue?vue&type=style&index=0&id=7804f1f8&lang=scss"

const __exports__ = script;

export default __exports__